export enum UserEndpoints {
    getUserExists = '/v1/user/{email}/exists',
}
